import { LineChart } from '@atlassian/mpac-ui';
import React from 'react';
import { findNoOfDaysBetweenDataPoints, getXLabelFormatterForDayWidth, LineChartWrapper } from '../../Common/ChartUtils';
import ReportChartTooltip from '../../ReportChartTooltip';
import ChartControls from '../../ReportsFilters/ChartControls';
import { reasonKeyToContent } from '../FeedbackReports.constants';
import { getChartData, getChartTooltipPairs, getHeaderConfig, getLines } from '../FeedbackReports.utils';
const FeedbackChart = props => {
  const {
    reportBy,
    source,
    feedbackSeries,
    sortedReasonKeyConfigs,
    reasonKeyConfigState,
    setReasonKeyConfigState,
    enableReportsAccessibilityChanges
  } = props;
  const headerConfig = getHeaderConfig(reportBy, source);
  const chartData = feedbackSeries.length > 0 ? getChartData(feedbackSeries, headerConfig) : [];
  const noOfDaysBetweenDataPoints = findNoOfDaysBetweenDataPoints(chartData);
  const chartTooltip = _ref => {
    let {
      active,
      label,
      payload,
      lines
    } = _ref;
    if (active && payload && payload.length) {
      const pairs = getChartTooltipPairs(payload, headerConfig, lines);
      return /*#__PURE__*/React.createElement(ReportChartTooltip, {
        head: label,
        pairs: pairs
      });
    }
    return null;
  };

  // X-axis for charts contains date strings
  const xLabelFormat = value => getXLabelFormatterForDayWidth(noOfDaysBetweenDataPoints)(value.toString());
  const exceedsFiveChartLines = sortedReasonKeyConfigs.length > 5;
  const chartFilterProps = enableReportsAccessibilityChanges && exceedsFiveChartLines ? {
    sortedConfigs: sortedReasonKeyConfigs,
    configState: reasonKeyConfigState,
    setConfigState: setReasonKeyConfigState,
    keyToContentMapper: key => reasonKeyToContent[key].name
  } : undefined;
  return /*#__PURE__*/React.createElement(LineChartWrapper, {
    enableReportsAccessibilityChanges: enableReportsAccessibilityChanges
  }, /*#__PURE__*/React.createElement(LineChart, {
    height: 500,
    lines: getLines(headerConfig, reasonKeyConfigState, enableReportsAccessibilityChanges),
    data: chartData,
    xLabelFormat: xLabelFormat,
    yLabelFormat: value => value,
    tooltip: chartTooltip
  }), /*#__PURE__*/React.createElement(ChartControls, {
    chartFilterProps: chartFilterProps,
    linePatternsUsageUserPreference: {
      value: true
    }
  }));
};
export default FeedbackChart;